import { Answers, ScenarioType, Steps } from '../state/interfaces'
import { getLocale } from '../i18n/locale'
import { getCookie } from '../scenarios'
import { formatPostalCode, updateCookieProvince } from '../scenarios/utils'

const locale = getLocale()

export function getPathname(scenarioType: string): string {
  switch (scenarioType) {
    case ScenarioType.MOBILE:
    case ScenarioType.MOBILE_ALERT:
    case ScenarioType.MOBILE_ALERT_OBSERVER:
    case ScenarioType.MOBILE_SEARCH_EMAIL:
    case ScenarioType.QUICK_SEARCH_MOBILE:
      // case ScenarioType.LEAD_MOBILE:
      return locale === 'en' ? 'compare-cellphone-plan' : 'comparer-forfait-cellulaire'
    case ScenarioType.INTERNET:
    case ScenarioType.INTERNET_ALERT:
    case ScenarioType.INTERNET_ALERT_OBSERVER:
    case ScenarioType.COMPETITION_INTERNET_ALERT:
    case ScenarioType.INTERNET_SPEED:
    case ScenarioType.LEAD_INTERNET:
      return locale === 'en' ? 'compare-internet-plan' : 'comparer-forfait-internet'
    case ScenarioType.ADVISE_INTERNET:
      return 'advise/internet'
    case ScenarioType.EMAIL_PAGE_GO_INTERNET:
    case ScenarioType.EMAIL_PAGE_GO_MOBILE:
      return 'go'
    default:
      return ''
  }
}

export function generateQueryUrlFragment(
  scenarioType: string,
  answers: Answers,
  scenarioAdditionalInformation: Record<string, unknown>,
): string {
  const providers = getProvidersList(scenarioAdditionalInformation, scenarioType)
  const cookiePostalCode = getCookie('internetSearchPostalcode').replace(/\s+/, '')
  switch (scenarioType) {
    case ScenarioType.MOBILE:
    case ScenarioType.MOBILE_ALERT:
    case ScenarioType.MOBILE_ALERT_OBSERVER:
    case ScenarioType.MOBILE_SEARCH_EMAIL:
    case ScenarioType.QUICK_SEARCH_MOBILE:
      // case ScenarioType.LEAD_MOBILE:
      const data = answers[Steps.HOW_MUCH_DATA]![0].match(/\d+(MB|Mo)/i)
        ? answers[Steps.HOW_MUCH_DATA]![0]
        : answers[Steps.SLIDER_DATA]![0]
        ? answers[Steps.SLIDER_DATA]![0]
        : '0MB'
      const options = extractOptions(answers)
      return `/${
        answers[Steps.HOW_MANY_CALLING_MINUTES] ? answers[Steps.HOW_MANY_CALLING_MINUTES]![0] : 'unlimitedcalls'
      }.${data}.${options}best.${answers[Steps.PHONE_MODEL_ID] ? answers[Steps.PHONE_MODEL_ID]![0] : '2'}.${providers}`
    case ScenarioType.INTERNET:
      const postalCodeInternet = cookiePostalCode
        ? cookiePostalCode
        : answers[Steps.POSTAL_CODE]
        ? answers[Steps.POSTAL_CODE]![0].replace(/\s+/, '')
        : 'nc'
      const internetUsageInternet: string | number = answers[Steps.MONTHLY_USAGE]![0]
      const downloadSpeedInternet = answers[Steps.DOWNLOAD_SPEED]![0]
      return `/?searchSlug=search&locality=nc&bandwidth=${internetUsageInternet}&postal=${postalCodeInternet}&downloadspeed=${downloadSpeedInternet}Mbps&uploadspeed=0Mbps&services=best&provider=all-carriers`
    case ScenarioType.INTERNET_ALERT:
    case ScenarioType.INTERNET_ALERT_OBSERVER:
    case ScenarioType.COMPETITION_INTERNET_ALERT:
      const postalCodeInternetAlert = getCookie('internetSearchPostalcode').replace(/\s+/, '')
      const internetUsageInternetAlert = 0
      let downloadSpeed = '0'
      // answers[Steps.MONTHLY_USAGE]![0] === 'unlimited'
      //   ? 'unlimited-data'
      //   : Number(answers[Steps.MONTHLY_USAGE]![0].replace(/GB/, '')) * 1000
      if (answers[Steps.INTERNET_SPEED]![0] === 'custom-speed') {
        if (answers[Steps.SLIDER_DATA_AMOUNT]) {
          downloadSpeed = answers[Steps.SLIDER_DATA_AMOUNT]![0]
        }
      } else {
        downloadSpeed = answers[Steps.INTERNET_SPEED]![0]
      }
      const downloadSpeedInternetAlert = downloadSpeed
      const downloadSpeedInternetAlertValue = downloadSpeedInternetAlert.replace(/mbps/i, '')
      return `/?searchSlug=search&locality=nc&bandwidth=${internetUsageInternetAlert}&postal=${postalCodeInternetAlert}&downloadspeed=${downloadSpeedInternetAlertValue}Mbps&uploadspeed=0Mbps&services=best&provider=all-carriers`
    case ScenarioType.ADVISE_INTERNET:
      const internetUsageInternetProvider: string | number = answers[Steps.MONTHLY_USAGE]![0]
      const downloadSpeedInternetProvider = answers[Steps.DOWNLOAD_SPEED]![0]
      const provider = scenarioAdditionalInformation?.internetEstimationProvider || 'undefined'
      return `/?dyn=1&bandwidth=${internetUsageInternetProvider}&downloadspeed=${downloadSpeedInternetProvider}Mbps&provider=${provider}`
    // case ScenarioType.QUICK_SEARCH_MOBILE:
    //   return `/${answers[Steps.HOW_MANY_CALLING_MINUTES]![0]}.${data}.${options}best.${
    //     answers[Steps.PHONE_MODEL_ID] ? answers[Steps.PHONE_MODEL_ID]![0] : '2'
    //   }.all-carriers`
    case ScenarioType.INTERNET_SPEED:
      const cookiePostalCodeISpeed = getCookie('internetSearchPostalcode').replace(/\s+/, '')
      const internetUsageInternetSpeed: string | number = answers[Steps.MONTHLY_USAGE]![0]
      const downloadSpeedInternetSpeed = answers[Steps.DOWNLOAD_SPEED]![0]
      const postalCodeInternetSpeed = cookiePostalCodeISpeed
        ? cookiePostalCodeISpeed
        : answers[Steps.POSTAL_CODE]
        ? answers[Steps.POSTAL_CODE]![0].replace(/\s+/, '')
        : 'nc'

      if (postalCodeInternetSpeed && postalCodeInternetSpeed === 'nc') {
        updateCookieProvince(postalCodeInternetSpeed)
      }
      return `/?searchSlug=search&locality=nc&bandwidth=${internetUsageInternetSpeed}&postal=${postalCodeInternetSpeed}&downloadspeed=${downloadSpeedInternetSpeed}Mbps&uploadspeed=0Mbps&services=1year&provider=all-carriers`
    // TODO LEAD_MOBILE case
    // case ScenarioType.LEAD_MOBILE:
    //   const data = answers[Steps.HOW_MUCH_DATA]![0].match(/\d+(MB|Mo)/i)
    //     ? answers[Steps.HOW_MUCH_DATA]![0]
    //     : answers[Steps.SLIDER_DATA]![0]
    //     ? answers[Steps.SLIDER_DATA]![0]
    //     : '0MB'
    //   const options = extractOptions(answers)
    //   return `/${
    //     answers[Steps.HOW_MANY_CALLING_MINUTES] ? answers[Steps.HOW_MANY_CALLING_MINUTES]![0] : 'unlimitedcalls'
    //   }.${data}.${options}2years.${
    //     answers[Steps.PHONE_MODEL_ID] ? answers[Steps.PHONE_MODEL_ID]![0] : '2'
    //   }.${providers}`
    case ScenarioType.LEAD_INTERNET:
      let postalCodeFromAddress = ''
      if (answers[Steps.ADDRESS_LOCATION] && answers[Steps.ADDRESS_LOCATION]![6]) {
        postalCodeFromAddress = formatPostalCode(answers[Steps.ADDRESS_LOCATION]![6])
      }

      if (!postalCodeFromAddress) {
        if (answers[Steps.NEW_CLIENT_VERIFICATION]) {
          postalCodeFromAddress = getCookie('internetSearchPostalcode') || getCookie('geo-postal-code')
        } else {
          postalCodeFromAddress = 'nc'
        }
      }
      postalCodeFromAddress = postalCodeFromAddress.replace(/\s+/, '')
      if (postalCodeFromAddress && postalCodeFromAddress !== 'nc') {
        updateCookieProvince(postalCodeFromAddress)
      }
      const internetUsageLeadInternet: string | number = 'unlimited-data'
      let downloadSpeedLeadInternet = scenarioAdditionalInformation.downloadSpeed || 0
      if (parseInt(downloadSpeedLeadInternet as string) > 1000) {
        downloadSpeedLeadInternet = 1000
      }
      return `/?searchSlug=search&locality=nc&bandwidth=${internetUsageLeadInternet}&postal=${postalCodeFromAddress}&downloadspeed=${downloadSpeedLeadInternet}Mbps&uploadspeed=0Mbps&services=best&provider=${providers}`
    default:
      return ''
  }
}

export function extractOptions(answers: Answers) {
  if (answers[Steps.CALLING_OPTIONS]) {
    if (answers[Steps.CALLING_OPTIONS]?.length === 0) {
      return '3G.4G.5G.'
    }
    return answers[Steps.CALLING_OPTIONS]?.join('.') + '.'
  }

  if (answers[Steps.COVERAGE]) {
    const options = answers[Steps.COVERAGE]?.filter(
      (option) => option !== 'only-province-coverage' && option !== 'i-dont-know-coverage',
    )
    if (options?.length === 0) {
      return '3G.4G.5G.unlimitedtext.voicemail.'
    } else {
      return '3G.4G.5G.unlimitedtext.voicemail.' + options?.join('.') + '.'
    }
  }
  return '3G.4G.5G.unlimitedtext.voicemail.'
}

export function getProvidersList(scenarioAdditionalInformation: Record<string, unknown>, scenarioType: string) {
  if (scenarioType === ScenarioType.LEAD_INTERNET) {
    if (scenarioAdditionalInformation.providerSlug === 'bell') {
      // return '1'
      return 'all-carriers'
    }
  }

  if (scenarioAdditionalInformation?.providerIdQuickSearch) {
    return scenarioAdditionalInformation.providerIdQuickSearch
  }

  return 'all-carriers'
}
